import { Injectable } from '@angular/core';
import { HttpClient,  HttpHeaders} from '@angular/common/http';
import { Observable} from 'rxjs';
import {environment} from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PriceValidService {
  public url!: string;
  
  constructor(
    public _http: HttpClient
  ) { 
  }

  searchSocio(request : any): Observable<any> {
    let ruta = environment.searchSocioAndComponent;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.post(ruta, params, { headers: headersResp });
  }
  searchDatosExcelFiltro(request : any): Observable<any> {
    let ruta = environment.searchDatosExcelFiltro;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.post(ruta, params, { headers: headersResp });
  }
  
  obtenerDatosSocios(): Observable<any> {
    let ruta = environment.partnerList;
    return this._http.get(ruta);
  }

  searchComponet(request : any): Observable<any> {
    let ruta = environment.searchComponent;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.post(ruta, params, { headers: headersResp });
  }

  putComponent(request: any) {
    let ruta = environment.priceValidComPutComponent;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.put(ruta, params, { headers: headersResp });
  }

  saveComponent(request: any) {
    let ruta = environment.priceValidComPostComponent;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.post(ruta, params, { headers: headersResp });
  }

  deleteComponent(request: any) {
    let ruta = environment.priceValidComDelComponent;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');    
    return this._http.post(ruta, params, { headers: headersResp });
  }

  cargaMasiva(request: any){
    let ruta = environment.cargaMasiva;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(ruta, params, { headers: headersResp });
  }
}